export const getBaseAddress = state => {
  if (!!state?.user?.company?.id) return "/company"
  return "/candidate"
}
